
      if (!import.meta.env.DEV) {
        const script = document.createElement("script");
        script.defer = true;
        script.src = "/script.js";
        script.setAttribute(
          "data-website-id",
          "88af7dad-0d4a-4c52-b167-1a3fb95c99ee",
        );
        script.setAttribute("data-performance", "true");
        document.head.appendChild(script);
      }
    